module.exports = __webpack_public_path__ + "img/logo.e69ec4ce.png";